import { cva, type VariantProps } from 'class-variance-authority';

export type ButtonVariantProps = VariantProps<typeof buttonVariants>;

export const buttonVariants = cva(
  'mm:border-0 mm:bg-background mm:inline-flex mm:items-center mm:justify-center mm:gap-2 mm:whitespace-nowrap mm:text-sm mm:font-medium mm:transition-all mm:cursor-pointer mm:focus-visible:outline-none mm:focus-visible:ring-1 mm:focus-visible:ring-ring mm:disabled:pointer-events-none mm:disabled:opacity-50 mm:[&_svg]:pointer-events-none mm:[&_svg]:size-4 mm:[&_svg]:shrink-0 mm:rounded-md mm:playful:rounded-full',
  {
    variants: {
      variant: {
        brand:
          'mm:bg-brand mm:text-primary-foreground mm:shadow mm:hover:bg-brand-accent',
        primary:
          'mm:bg-primary mm:text-primary-foreground mm:shadow mm:hover:bg-primary/90',
        outline:
          'mm:border mm:border-input mm:bg-background mm:shadow-sm mm:hover:bg-accent mm:hover:text-accent-foreground mm:rounded-md',
        secondary:
          'mm:bg-secondary mm:text-secondary-foreground mm:shadow-sm mm:hover:bg-secondary/80',
        ghost: 'mm:hover:bg-accent mm:hover:text-accent-foreground',
        link: 'mm:text-primary mm:underline-offset-4 mm:hover:underline',
      },
      size: {
        default: 'mm:h-9 mm:px-4 mm:py-2',
        xs: 'mm:h-6 mm:w-6',
        sm: 'mm:h-8 mm:px-3 mm:text-xs',
        lg: 'mm:h-10 mm:px-8 mm:text-lg',
        icon: 'mm:h-9 mm:w-9',
      },
    },
    defaultVariants: {
      variant: 'primary',
      size: 'default',
    },
  }
);
